module.exports = __webpack_public_path__ + "static/media/phone4x.d94ab5ce.png";